<ng-select
    [items]="people$ | async"
    [multiple]="true"
    [closeOnSelect]="false"
    [searchable]="false"
    bindLabel="name"
    placeholder="Select people"
    [(ngModel)]="selectedPeople">
</ng-select>

<div class="mt-3">
    Selected value: <br/>
    <ul>
        <li *ngFor="let item of selectedPeople">{{item.name}}</li>
    </ul>
    <button (click)="clearModel()" class="btn btn-secondary btn-sm ms-2">Clear model</button>
    <button (click)="changeModel()" class="btn btn-primary btn-sm">Change model</button>
</div>